<template>
  <VTable
    v-if="table.data.length"
    :table="table"
    class="manager-company-opportunity-lookup-external-events"
  />
  <VFallbackText v-else>No data found</VFallbackText>
</template>

<script setup lang="ts">
  // Types
  import type { ITable } from '~/misc/v-table/types';
  import type { TManagerCompanyOpportunityLookupExternalEvent } from '~/modules/manager/types';

  // Config
  import { TABLE_HEADERS } from '~/modules/manager/company/opportunity-lookup/result/external-events/config';

  // Utils
  import { DateTimeFormatter } from '~/misc/utils/datetime';

  // Components
  import VTable from '~/misc/v-table';
  import VFallbackText from '~/misc/v-fallback-text/VFallbackText.vue';

  const props = defineProps({
    data: {
      type: Array as PropType<TManagerCompanyOpportunityLookupExternalEvent[]>,
      required: true,
    },
  });

  const table: ComputedRef<ITable> = computed<ITable>(() => ({
    headers: TABLE_HEADERS,
    data: props.data.length
      ? props.data.map((item: TManagerCompanyOpportunityLookupExternalEvent) => [
          item.name,
          item.source || '-',
          item.date ? DateTimeFormatter.toShortDate(item.date) : '-',
          item.description || '-',
        ])
      : [],
  }));
</script>
